/**
 * SupplierPayment Zod schemalari — taminotchiga to'lov (Phase 5).
 *
 * Balans formulasi:
 *   balance = SUM(stockMovement.IN.unitCost × quantity) − SUM(payments)
 *   - Musbat → siz qarzdorsiz (taminotchiga shu summa qarzdoringiz)
 *   - Manfiy → ortiqcha to'lagansiz (avans)
 *   - 0     → toza
 */
import { z } from 'zod';
import { uuidSchema } from './common.schema.js';
import { currencyEnum } from './product.schema.js';
export const createSupplierPaymentSchema = z.object({
    supplierId: uuidSchema,
    amount: z.coerce.number().min(0.01),
    currency: currencyEnum,
    method: z.enum(['NAQD', 'KARTA', 'BANK', 'BOSHQA']).optional(),
    note: z.string().max(500).optional(),
    paidAt: z.string().datetime().optional(),
});
export const listSupplierPaymentsSchema = z.object({
    supplierId: uuidSchema.optional(),
    dateFrom: z.string().datetime().optional(),
    dateTo: z.string().datetime().optional(),
    limit: z.coerce.number().int().min(1).max(500).default(50),
    cursor: z.string().max(200).optional(),
});
//# sourceMappingURL=supplier-payment.schema.js.map